import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { LogOut, Sparkles, ArrowRightLeft } from "lucide-react";

export default function Profile() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = async () => {
    await logout();
    nav("/welcome");
  };

  return (
    <div className="flex-1 flex flex-col p-6 grain">
      <header className="pt-8">
        <p className="text-xs tracking-[0.3em] uppercase text-muted-foreground">You</p>
        <div className="mt-3 flex items-baseline gap-3 flex-wrap">
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight" data-testid="profile-name">{user?.name}</h1>
          {user?.is_premium && (
            <span className="text-[10px] tracking-[0.3em] uppercase text-primary flex items-center gap-1" data-testid="profile-premium-badge">
              <Sparkles className="h-3 w-3" strokeWidth={1.5} /> Premium
            </span>
          )}
        </div>
        <p className="mt-2 text-muted-foreground">{user?.email}</p>
      </header>

      <section className="mt-10 space-y-6">
        <div>
          <p className="text-[11px] tracking-[0.3em] uppercase text-muted-foreground mb-1">Languages</p>
          <p className="text-lg flex items-center gap-2 flex-wrap" data-testid="profile-languages">
            <span>{user?.native_language}</span>
            <ArrowRightLeft className="h-4 w-4 text-muted-foreground" strokeWidth={1.5} />
            <span className="text-secondary">{user?.learning_language}</span>
          </p>
        </div>
        {user?.bio ? (
          <div>
            <p className="text-[11px] tracking-[0.3em] uppercase text-muted-foreground mb-1">About</p>
            <p className="font-serif italic text-lg text-foreground/80 leading-relaxed" data-testid="profile-bio">"{user.bio}"</p>
          </div>
        ) : null}

        {!user?.is_premium && (
          <Link to="/premium" data-testid="profile-upgrade-link">
            <div className="rounded-3xl border border-primary/40 bg-primary/5 p-5 hover:bg-primary/10 transition-colors">
              <div className="flex items-center gap-2 text-primary">
                <Sparkles className="h-4 w-4" strokeWidth={1.5} />
                <p className="text-[11px] tracking-[0.3em] uppercase">Go Premium</p>
              </div>
              <p className="mt-2 font-serif text-2xl leading-tight">Two people a day, and a translator.</p>
              <p className="mt-1 text-sm text-muted-foreground">$4.99/month · cancel any time</p>
            </div>
          </Link>
        )}
      </section>

      <div className="mt-auto pb-4 pt-10">
        <Button
          variant="outline"
          onClick={doLogout}
          className="w-full h-12 rounded-full border-border text-foreground/80 hover:bg-muted"
          data-testid="logout-btn"
        >
          <LogOut className="h-4 w-4 mr-2" strokeWidth={1.5} /> Sign out
        </Button>
      </div>
    </div>
  );
}
